// src/utils/constants.js

export const DRIVER_LICENSE_TYPES = [
  { label: 'A1', value: 'A1' },
  { label: 'A2', value: 'A2' },
  { label: 'A3', value: 'A3' },
  { label: 'B1', value: 'B1' },
  { label: 'B2', value: 'B2' },
  { label: 'C1', value: 'C1' },
  { label: 'C2', value: 'C2' },
  { label: 'C3', value: 'C3' },
  { label: 'C4', value: 'C4' },
  { label: 'C5', value: 'C5' },
  { label: 'C6', value: 'C6' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
  { label: 'F', value: 'F' },
  { label: 'M', value: 'M' },
  { label: 'N', value: 'N' },
  { label: 'P', value: 'P' }
]
